import { STREAM_TYPE_LABELS, StreamType } from './enums';

export const STREAM_TYPES = [
  {
    key: StreamType.Standard,
    value: StreamType.Standard,
    label: STREAM_TYPE_LABELS[StreamType.Standard],
    shortLabel: 'Std',
  },
  {
    key: StreamType.Accelerated,
    value: StreamType.Accelerated,
    label: STREAM_TYPE_LABELS[StreamType.Accelerated],
    shortLabel: 'Acc',
  },
  {
    key: StreamType.Holiday,
    value: StreamType.Holiday,
    label: STREAM_TYPE_LABELS[StreamType.Holiday],
    shortLabel: 'Hol',
  },
];

const listAttributes = [
  'course',
  'streamId',
  'label',
  'shortLabel',
  'groupCode',
  'active',
  'gradYear',
  'groupName',
  'type',
  'separatelyBilled',
  'priceId',
] as const;

const getAttributes = [
  ...listAttributes,
  'scheduleLink',
  'basePermissions',
  'slackIds',
  'orderedLessons',
] as const;

const updateAttributes = [
  'groupCode',
  'scheduleLink',
  'gradYear',
  'groupName',
  'type',
  'slackIds',
  'orderedLessons',
  'active',
  'separatelyBilled',
  'priceId',
] as const;

// The codec composes these from the cohort fields when a row is read, so they
// are readable but never written, and stay outside Update so nothing can set them
// out of step with the fields they are composed from.
const composedAttributes = ['label', 'shortLabel'] as const;

export const StreamAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
  Composed: composedAttributes,
};
